export const PageIdentityManagement = "/identity-management";
export const PageIdentityDetails = "/details";
export const PageConfiguration = "/configuration";
export const PageCoco = "/coco";
export const PageCocoRemoteConsent = "/coco/remote-consent";
export const PageCocoPaperConsent = "/coco/paper-consent";
export const PageCocoProfileUpdate = "/coco/profile-update";
export const PageContentLibrary = "/contentlibrary";
export const PageFileManagement = "/file-management";

export const ActionRemoteConsentCollect = "remote-consent-collect";
export const ActionRefreshProfile = "refresh-profile";
export const ActionDeleteIdentity = "delete-identity";
export const ActionMenuConfluence = "side-menu-confluence";
export const ActionMenuThoughtSpot = "side-menu-thought-spot";
export const ActionMenuSupport = "side-menu-support";

export const FieldSalutation = "salutation";
export const FieldTitle = "title";
export const FieldFirstName = "first-name";
export const FieldLastName = "last-name";
export const FieldType = "type";
export const FieldValue = "value";
export const FieldLangugae = "language";
export const FieldContactEmail = "contact-email";

export const ActionCreateIdentity = "create-identity";
export const ActionSearchIdentity = "search-identity";
export const ActionShowIdentity = "show-identity";
export const ActionEditIdentity = "edit-identity";
export const ActionTabConsentProcessing = "consent-processing";
export const ActionTabLegitimateInterest = "legitimate-interest";
export const ActionTabSubIdentitiesAndAliases = "sub-identities-and-aliases";
export const ActionTabSources = "sources";
export const ActionTabEmailActivity = "email-activity";
export const ActionOptout = "optout";
export const ActionOptoutAllConsent = "optout-all-consent";
export const ActionOptoutAll = "optout-all";
export const ActionCreateSubIdAlias = "create-sub-id-alias";
export const ActionDeleteSubIdAlias = "delete-sub-id-alias";
export const ActionSubIdAliasHistory = "sub-id-alias-history";
export const ActionCocoLinkGenerator = "coco-link-generator";